import { render, staticRenderFns } from "./TBI.vue?vue&type=template&id=101bdca1&"
import script from "./TBI.vue?vue&type=script&lang=js&"
export * from "./TBI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports